// How a trainer is drawn: their outfit's art in their own hair style, skin tone and hair colour (shared/looks.ts).
// Every place that draws a trainer asks here for the sprite id: the field and the corner view draw its sheet
// (sheet/sheetInfo), menus and player icons its stills (`${id}-<down|left|up|right>-0`, spriteUrl) or
// trainerSheetUrl. Art owns this file.
import { outfitOf } from '../shared/outfits.ts';
import { HAIR_STYLES, DEFAULT_LOOK, splitWorn, lookOf, type Look } from '../shared/looks.ts';
import { has, trainerTint } from './assets.ts';
import { S } from './state.ts';

/**
 * The sprite id for an outfit id or a worn code ("keeper~s3h2c4", as the server sends other trainers), in its look;
 * `look` (a Look or a look code) replaces the worn code's. A hair style the outfit hides (under a hood or hat) draws
 * as the outfit's plain art.
 */
export function trainerSprite(worn: string | null | undefined, look?: Look | string | null): string {
  const w = splitWorn(worn);
  const l = look == null ? w.look : typeof look === 'string' ? lookOf(look) : look;
  const fit = outfitOf(w.outfit).sprite;
  const styled = `${fit}~${HAIR_STYLES[l.hair]?.id}`;
  const base = l.hair !== DEFAULT_LOOK.hair && has(styled) ? styled : fit;
  return l.skin === DEFAULT_LOOK.skin && l.color === DEFAULT_LOOK.color ? base : trainerTint(base, `s${l.skin}c${l.color}`);
}

/** The signed-in trainer's sprite id: what they wear, or `outfit` (an outfit preview), in their own look. */
export function mySprite(outfit?: string): string {
  return trainerSprite(outfit ?? S.trainer?.outfit, S.trainer?.look ?? null);
}
